var map = {
	"./angry-red.png": 1730,
	"./angry.png": 1731,
	"./anguished.png": 1732,
	"./anxious.png": 1733,
	"./beaming-face.png": 1734,
	"./confounded-normal.png": 1735,
	"./confounded.png": 1736,
	"./confused.png": 1737,
	"./crying-loudly.png": 1738,
	"./crying.png": 1739,
	"./devil.png": 1740,
	"./disappointed.png": 1741,
	"./distraught.png": 1742,
	"./dizzy.png": 1743,
	"./downcast.png": 1744,
	"./expressionless.png": 1745,
	"./fearful.png": 1746,
	"./frowning-eyebrows.png": 1747,
	"./frowning.png": 1748,
	"./grimacing.png": 1749,
	"./grinning-smiling-eyes.png": 1750,
	"./grinning-smiling-squinting-eyes.png": 1751,
	"./grinning.png": 1752,
	"./hand-1.png": 1753,
	"./hand-2.png": 1754,
	"./hand-3.png": 1755,
	"./hand-4.png": 1756,
	"./hand-5.png": 1757,
	"./inlove.png": 1758,
	"./innocent.png": 1759,
	"./kissing-closed-eyes.png": 1760,
	"./kissing.png": 1761,
	"./laughing.png": 1762,
	"./mask.png": 1763,
	"./neutral.png": 1764,
	"./persevering.png": 1765,
	"./relieved.png": 1766,
	"./sad.png": 1767,
	"./screaming.png": 1768,
	"./shy.png": 1769,
	"./sleepy.png": 1770,
	"./smile-licky.png": 1771,
	"./smile.png": 1772,
	"./smirk.png": 1773,
	"./smoked.png": 1774,
	"./steamy.png": 1775,
	"./stick-out-tongue.png": 1776,
	"./sunglasses.png": 1777,
	"./surprised.png": 1778,
	"./tongue-out.png": 1779,
	"./unamused.png": 1780,
	"./weary.png": 1781,
	"./wink-licky.png": 1782,
	"./wink.png": 1783,
	"./without-mouth.png": 1784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2155;